import { Link } from "react-router-dom";
import { ArrowRight, Clock } from "lucide-react";
import { blogPosts } from "@/data/blogPosts";

const fmtDate = (iso) => new Date(iso).toLocaleDateString("en-GB", { day: "numeric", month: "short", year: "numeric" });

// Two other posts: same category first, then most recent.
export function relatedPosts(current, count = 2) {
  const score = (p) => (p.category === current.category ? 1 : 0);
  return blogPosts
    .filter((p) => p.slug !== current.slug)
    .sort((a, b) => score(b) - score(a) || new Date(b.date) - new Date(a.date))
    .slice(0, count);
}

export function RelatedPosts({ post }) {
  const picks = relatedPosts(post);
  if (!picks.length) return null;
  return (
    <section className="mt-16" data-testid="related-posts">
      <span className="text-sm text-[#0EA5E9] tracking-[0.2em] uppercase font-bold">Keep reading</span>
      <h2 className="mt-2 font-heading text-2xl font-bold text-[#0F172A]">You might also like</h2>
      <div className="mt-6 grid sm:grid-cols-2 gap-5">
        {picks.map((p) => (
          <Link
            key={p.slug}
            to={`/blog/${p.slug}`}
            className="group flex flex-col bg-white rounded-[1.5rem] overflow-hidden border border-slate-100 shadow-sm hover:shadow-xl hover:-translate-y-1 transition-all duration-300"
            data-testid={`related-post-${p.slug}`}
          >
            <div className="h-40 overflow-hidden">
              <img src={p.heroImage} alt={p.heroAlt} loading="lazy" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
            </div>
            <div className="p-5 flex flex-col flex-1">
              <span className="text-[11px] font-bold uppercase tracking-wider text-[#0EA5E9]">{p.category}</span>
              <h3 className="mt-1.5 font-heading text-lg font-bold text-[#0F172A] leading-snug group-hover:text-[#FF7A1A] transition-colors">{p.title}</h3>
              <div className="mt-auto pt-4 flex items-center justify-between text-xs text-[#94A3B8]">
                <span className="inline-flex items-center gap-1.5"><Clock size={13} /> {p.readTime} · {fmtDate(p.date)}</span>
                <span className="inline-flex items-center gap-1 font-bold text-[#FF7A1A]">Read <ArrowRight size={13} className="group-hover:translate-x-0.5 transition-transform" /></span>
              </div>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}
